import axios from 'axios'

const api = axios.create({
  baseURL: '/api/bookmarks',
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('user_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface BookmarkFolder {
  folder_id: string
  user_id: string
  name: string
  color?: string | null
  created_at: string
  bookmark_count?: number
}

export interface Bookmark {
  bookmark_id: string
  pmid: string
  folder_id?: string | null
  created_at: string
  article?: {
    pmid: string
    title?: string
    authors?: string[]
    authors_full?: string
    affiliations?: string[]
    author_emails?: string[]
    journal?: string
    journal_abbrev?: string
    year?: number
    abstract?: string
    keywords?: string[]
    mesh_terms?: string[]
    pub_types?: string[]
    doi?: string
    issn?: string
    quartile?: string
    sjr_score?: number
    h_index?: number
    citations?: number
    citations_per_year?: number
    rcr?: number
    field_citation_rate?: number
    nih_percentile?: number
    cited_by_pmids?: string[]
    references_pmids?: string[]
    created_at?: string
    updated_at?: string
  }
}

export const bookmarkApi = {
  listBookmarks: (folder_id?: string | null) => {
    const params: any = {}
    if (folder_id !== undefined && folder_id !== null) params.folder_id = folder_id
    return api.get('', { params }).then(r => r.data as Bookmark[])
  },

  addBookmark: (pmid: string, folder_id?: string | null) =>
    api.post('', { pmid, folder_id: folder_id ?? null }).then(r => r.data),

  removeBookmark: (pmid: string) =>
    api.delete(`/${pmid}`).then(r => r.data),

  moveBookmark: (pmid: string, folder_id: string | null) =>
    api.patch(`/${pmid}`, { folder_id }).then(r => r.data),

  checkBookmark: (pmid: string) =>
    api.get(`/check/${pmid}`).then(r => r.data.bookmarked as boolean),

  // Folders
  listFolders: () =>
    api.get('/folders').then(r => r.data as BookmarkFolder[]),

  createFolder: (data: { name: string; color?: string | null }) =>
    api.post('/folders', data).then(r => r.data as BookmarkFolder),

  updateFolder: (folderId: string, data: { name?: string; color?: string | null }) =>
    api.patch(`/folders/${folderId}`, data).then(r => r.data as BookmarkFolder),

  deleteFolder: (folderId: string) =>
    api.delete(`/folders/${folderId}`).then(r => r.data),
}
